import React, {useState} from 'react'
import {useIntl} from 'react-intl'
import {DimCalculator} from './DimCalculator'
import {UspsZoneCalculator} from './UspsZoneCalculator'

const TABS = [
  {id: 'dim', labelId: 'DIM_CALCULATOR', component: DimCalculator},
  {id: 'usps-zone', labelId: 'USPS_ZONE_CALCULATOR', component: UspsZoneCalculator},
] as const

type TabId = typeof TABS[number]['id']

export function AddressRateTools() {
  const intl = useIntl()
  const [activeTab, setActiveTab] = useState<TabId>(TABS[0].id)

  return (
    <section className='shipping-calc__tools-section py-30'>
      <div className='d-flex flex-column justify-content-center align-items-center gap-12 shipping-calc__section-width mx-auto px-4'>
        <div className='d-flex flex-column align-items-center w-100'>
          <h2 className='shipping-calc__heading lh-normal shipping-calc__title text-dark text-center mb-7'>
            {intl.formatMessage({id: 'ADDRESS_AND_RATE_ACCURACY_TOOLS'})}
          </h2>
          <p className='shipping-calc__subtitle fs-2 fw-bold text-center mb-0'>
            {intl.formatMessage({id: 'ADDRESS_RATE_TOOL_DESC_1'})}
          </p>
          <p className='shipping-calc__subtitle fs-2 fw-bold text-center mb-0'>
            {intl.formatMessage({id: 'ADDRESS_RATE_TOOL_DESC_2'})}
          </p>
        </div>

        {/* Tab buttons */}
        <div
          className='d-flex flex-wrap justify-content-center gap-4 w-100 mt-6'
          role='tablist'
          aria-label={intl.formatMessage({id: 'ADDRESS_AND_RATE_ACCURACY_TOOLS'})}
        >
          {TABS.map((tab) => (
            <button
              key={tab.id}
              role='tab'
              aria-selected={activeTab === tab.id}
              aria-controls={`tabpanel-${tab.id}`}
              id={`tab-${tab.id}`}
              className={`shipping-calc__tool-tab fw-boldest ${
                activeTab === tab.id ? 'shipping-calc__tool-tab--active' : ''
              }`}
              onClick={() => setActiveTab(tab.id)}
            >
              {intl.formatMessage({id: tab.labelId})}
            </button>
          ))}
        </div>

        {/* Active tool content */}
        <div className='w-100'>
          {TABS.map((tab) => (
            <div
              key={tab.id}
              role='tabpanel'
              id={`tabpanel-${tab.id}`}
              aria-labelledby={`tab-${tab.id}`}
              className={activeTab === tab.id ? '' : 'd-none'}
            >
              <tab.component />
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
